import styled from 'styled-components';

export const ContentVideo = styled.div`
  min-width: 0;
  width: 100%;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(28, 45, 56, 0.03);

  .link-video { display: block; height: 100%; }
`;

export const ThumbContent = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #e9edf1;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    display: block;
  }
`;

export const ContentChannelInfos = styled.div`
  padding: 18px 18px 8px;

  h4 {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.6;
    color: #263c4a;
    margin: 0;
  }
`;

export const Button = styled.div`
  margin-top: auto;
  padding: 8px 18px 18px;

  .button {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    color: #bc482b;
    font-size: 12px;
    font-weight: 600;
  }
`;

export const TutorialCardButton = styled.button`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 1px solid #e1e6ec;
  border-radius: 14px;
  overflow: hidden;
  background: transparent;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 160ms ease, background 160ms ease;

  &:hover {
    border-color: #ec6643;
    background: #fffaf7;
  }

  &[aria-pressed='true'] {
    border-color: #ec6643;
    background: #fff4ed;
    box-shadow: inset 0 0 0 1px #ec6643;
  }

  &:focus-visible {
    outline: 3px solid #bc482b;
    outline-offset: -3px;
  }

  @media (prefers-reduced-motion: reduce) { transition: none; }
`;
